/* @flow */

import { callLiferayEndpoint } from './index';
import utils from './utils';

import type { Broadcasting } from 'types';

const find = async (): Promise<Broadcasting[]> => {
  const response = await callLiferayEndpoint(
    '/protones-portlet.usermanagement/get-user-emittenti',
    {}
  );
  return response.map(utils.toBroadcasting);
};

export default {
  find,
};
